import { permissionTypeValues, userTypeValues } from 'constants/users';
import * as Yup from 'yup';
import { requiredField } from './utils/messages';

function testPermission(value: any, ctx: any) {
  const admin = ctx.parent.admin;

  if (admin === userTypeValues.client) {
    if (!value) {
      return false;
    }

    return true;
  }

  return true;
}

function testExpirationDate(value: any, ctx: any) {
  const admin = ctx.parent.admin;
  const permissionType = ctx.parent.permissionType;

  if (admin === userTypeValues.client && permissionType === permissionTypeValues.temporary) {
    if (!value) {
      return false;
    }

    return true;
  }

  return true;
}

export const usersValidationSchema = (isClient?: boolean) =>
  Yup.object().shape({
    name: Yup.string().required(requiredField),
    username: Yup.string().required(requiredField),
    email: Yup.string().required(requiredField),
    jobTitle: Yup.string().required(requiredField),
    department: Yup.string().required(requiredField),
    admin: Yup.number()
      .test('isClient', requiredField, val => {
        if (isClient) return true;
        else if ((typeof val).match(/(number|string)/i)) return true;
        return false;
      })
      .typeError(requiredField),
    permissionType: Yup.mixed().test('testPermissionType', requiredField, testPermission),
    expirationDate: Yup.mixed().test('testExpirationDate', requiredField, testExpirationDate),
  });
